interface ProcessStep {
  number: number;
  title: string;
  description: string;
}

interface ProcessStepsProps {
  steps: ProcessStep[];
  badge?: string;
  /** Extra content rendered inside a step, keyed by step number — e.g. a CTA
   *  that belongs to that step rather than to the section as a whole. */
  stepAddons?: Record<number, React.ReactNode>;
}

/**
 * ProcessSteps
 *
 * Numbered process visualisation used by `process.steps`-style sections.
 * Renders horizontally on wide screens and stacks vertically on mobile.
 * `badge` optionally prints a short pill (e.g. "48 Stunden") in the header.
 */
export default function ProcessSteps({ steps, badge, stepAddons }: ProcessStepsProps) {
  if (!Array.isArray(steps) || steps.length === 0) {
    throw new Error("ProcessSteps: `steps` array is empty or invalid.");
  }

  return (
    <div className="process-steps">
      {badge ? <span className="process-badge">{badge}</span> : null}
      <ol className="process-steps-grid">
        {steps.map((step) => (
          <li className="process-step" key={`${step.number}-${step.title}`}>
            <div className="process-step-num">{String(step.number).padStart(2, "0")}</div>
            <h3>{step.title}</h3>
            <p>{step.description}</p>
            {stepAddons?.[step.number] ?? null}
          </li>
        ))}
      </ol>
    </div>
  );
}
